<div
  class="content-padding status-badge"
  [class.badge-color-success]="type === 'success'"
  [class.badge-color-warning]="type === 'warning'"
  [class.badge-color-error]="type === 'error'"
  [class.cg-bold]="style === 'bold'"
  [class.cg-font-size-m]="size === 'medium'"
  [class.cg-font-size-ml]="size === 'large'"
  [attr.data-test]="'status-badge-' + type"
>
  {{ text }}
</div>
